import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export const SafePayOff = () => {
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'learningCenter',
  });

  return (
    <View style={styles.outerContainer}>
      <BodyBaseText>
        {translatedText('howToBuildCredit.safePayOffString.screenLabel')}
      </BodyBaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});
